// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"K_TheComp__napTL"};